<template lang="en">
<div class="doctor-profile">
    <Navigation></Navigation>
    
    <Loader :show="loading" type="inline"></Loader>

    <div class="container margin_60" v-if="!loading">
        <div class="row">

            <aside class="col-12 col-lg-3" id="sidebar" >
                <div class="box_profile">

                    <div class="box_profile_image">
                        <figure class="mb-2">
                            <div class="avatar" v-if="clinic.picture" :style="'background-image:url('+API_URL+clinic.picture.urlThumb+')'"></div>
                            <div class="avatar" v-else :style="'background-image:url('+require('@/assets/img/no-avatar-image.gif')+')'"></div>
                        </figure>
                    </div>

                    <div class="box_profile_info pb-3">
                        <!-- <div class="especialities">
                            <small  v-for="service in clinic.services" :key="service.id">
                                {{service.service.name}}
                            </small>
                        </div> -->
                    
                        <h1>{{clinic.name}}</h1>
                        <!-- <star-rating :star-size="14" :read-only="true" :show-rating="false" :rating="clinic.rate"  inactive-color="#ddd" :inline="true"></star-rating> -->
                                        
                        
                        <!-- <ul class="contacts" v-if="clinic.addresses.length>0 && !showOnlySelectedService">
                            <li v-for="address in clinic.addresses">
                                <h6>Ubicación</h6>{{address.locality.name}}, {{address.locality.region.name}}
                            </li>
                        </ul>
                        
                        
                        <ul class="contacts" v-if="purchase && purchase.service.addresses && purchase.service.addresses.length>0 && showOnlySelectedService">
                            <li v-for="address in purchase.service.addresses">
                                <h6>Ubicación</h6>{{address.locality.name}}, {{address.locality.region.name}}
                            </li>
                        </ul> -->


                        
                        <!-- <div class="">
                            <table class="table table-sm table-borderless services-table">
                                <thead>
                                    <tr>
                                        <th>Servicio</th>
                                        <th>Precio</th>
                                    </tr>
                                </thead>
                                <tbody v-for="service in clinic.services" :key="service.id">
                                    <tr>
                                        <td class="text-left">
                                            {{service.service.name}}
                                        </td>
                                        <td>${{service.price}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> -->
                    </div>
                </div>
            </aside>
            

            <div class="col-md-12 col-lg-9 ">

                <div class="tabs_styled_2">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <div class="nav-link" @click="selectedtab='booking'" :class="{'active':selectedtab=='booking'}">Contratar servicio</div>
                        </li>
                        <!-- <li class="nav-item">
                            <div class="nav-link" @click="selectedtab='general'" :class="{'active':selectedtab=='general'}" >Formación</div>
                        </li> -->
                        <!-- <li class="nav-item">
                            <div class="nav-link"@click="selectedtab='reviews'" :class="{'active':selectedtab=='reviews'}" >Reseñas</div>
                        </li> -->
                    </ul>

                    <div class="tab-content">

                        <div class="tab-pane fade show" :class="{'active':selectedtab=='booking'}">
                            
                            <form >

                                <div v-if="clinic.services.length>0">
                                    <div class="main_title_3" >
                                        <h3><strong>1</strong>Seleccioná el servicio </h3>
                                    </div>
                                    <ul class="treatments clearfix m-0">
                                        <li  v-for="service in clinic.services" :key="service.id">
                                            <div class="custom-control custom-radio" v-if="(showOnlySelectedService && purchase.service==service) || !showOnlySelectedService">
                                                <input type="radio" 
                                                    name="especiality" 
                                                    class="custom-control-input" 
                                                    :id="'especiality'+service.id" 
                                                    :checked="purchase.service==service"
                                                    >
                                                <label 
                                                    class="custom-control-label" 
                                                    :for="'especiality'+service.id"
                                                    @click="selectService(service)"
                                                    >
                                                    <span class="text-secondary">{{service.service.category.name}}</span>
                                                    {{service.service.name}}
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                    <router-link tag="a" :to="$route.path" class="btn btn-sm btn-light mt-2" v-if="showOnlySelectedService && clinic.services.length>1">Ver más servicios</router-link>
                                </div>
                                
                                

                                <div class="main_title_3 mt-4" v-if="purchase.service.addresses && purchase.service.addresses.length>1" >
                                    <h3><strong>2</strong>Seleccioná la ubicación</h3>
                                </div>
                                <ul class="treatments clearfix m-0" v-if="purchase.service.addresses && purchase.service.addresses.length>1">
                                    <li  v-for="address in purchase.service.addresses" :key="address.id">
                                        <div class="custom-control custom-radio ">
                                            <input type="radio" 
                                                name="address" 
                                                class="custom-control-input" 
                                                :id="'address'+address.id" 
                                                :checked="purchase.address.id==address.id"
                                                >
                                            <label 
                                                class="custom-control-label" 
                                                :for="'address'+address.id"
                                                @click="selectAddress(address)"
                                                >
                                                {{address.locality.name}}, {{address.locality.region.name}}
                                            </label>
                                        </div>
                                    </li>
                                </ul>

                            </form>
                            <hr>

                            <div class="alert alert-danger" v-if="purchaseFieldsError">
                                Seleccione un servicio y una ubicación para continuar.
                            </div>

                            <div class="text-center" v-if="purchase.service && purchase.service.id">
                                <button class="btn_1 medium"
                                    @click="confirmPurchase"
                                    >Continuar <span v-if="purchase.service.id>0">( $ {{purchase.price }} )</span>
                                </button>
                            </div>

                        </div>

                        <!-- <div class="tab-pane fade show" :class="{'active':selectedtab=='general'}">
                            <div class="indent_title_in">
                                <i class="pe-7s-study"></i>
                                <h3>Educación</h3>
                            </div>
                            <div class="wrapper_indent">
                                <p>
                                    {{medic.education_review}}
                                </p>
                                
                                <div v-for="medicEspeciality in medic.medicEspecialities" :key="medicEspeciality.id" class="especiality-item mt-3">
                                    <div class="indent_title_in mb-1">
                                        <i class="pe-7s-news-paper"></i>
                                        {{medicEspeciality.especiality.name}} | {{medicEspeciality.university}}
                                        <h3>{{medicEspeciality.title}}</h3>
                                    </div>
                                    <div class="wrapper_indent">
                                        <p>{{medicEspeciality.description}}</p>
                                        <h6 v-if="medicEspeciality.medicSubespecialities.length>0">Especializaciones</h6>
                                        <div class="row" v-if="medicEspeciality.medicSubespecialities.length>0">
                                            <div class="col-lg-6">
                                                <ul class="bullets">
                                                    <li v-for="medicSubespeciality in medicEspeciality.medicSubespecialities">
                                                        {{medicSubespeciality.subespeciality.name}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        
                        <!-- 
                        <div class="tab-pane fade show" :class="{'active':selectedtab=='reviews'}">
                            <MedicValorations :id="medic.id" v-if="selectedtab=='reviews'"></MedicValorations>
                        </div> -->

                    </div>
                </div>
            </div>
        </div>
    </div>

    <b-modal id="modal-login" size="sm" centered  hide-footer hide-header>
        <LoginBox @logged="closeLoginModal"></LoginBox>
    </b-modal>
    

    <Footer :shareTitle="`${clinic.name} está esperando que coordines tu consulta en DoctorConsultas`"></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters, mapMutations } from 'vuex'

import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import Loader from '@/components/Loader';
import LoginBox from '@/components/LoginBox';
import ContactForm from '@/components/ContactForm';

export default {
    name: 'ClinicProfile',
    metaInfo() {
        return{
            title: this.clinic.name,
        }
	},
    components: {
        Navigation,
        Footer,
        Loader,
        LoginBox,
        ContactForm
    },
    computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
	},
    data() {
        return {
            API_URL: process.env.VUE_APP_API_URL,
            clinic: {},
            loading: true,
            id: this.$route.params.id,
            selectedtab: 'booking',
            steps:1,
            purchase:{
                address:{
                    id:null
                },
                service:{},
                coupon: null,
                price:null
            },
            purchasing:false,
            purchaseFieldsError:false,
            showOnlySelectedService:false
        }
    },
    beforeMount(){
        console.log(this.$route.path)
    },
    apollo: {
        clinicCenter: {
            query: gql `query getClinicCenter($id: ID!) {
                clinicCenter(id: $id) {
                    id
                    name
                    picture{
                        urlThumb
                    }
                    services{
                        id
                        service{
                            id
                            slug
                            name
                            category{ name }
                        }
                        addresses{
                            id
                            locality{
                                name
                                region{
                                    name
                                }
                            }
                        }
                        price
                    }
                    addresses{
                        id
                        locality{
                            name
                            region{
                                name
                            }
                        }
                    }
                    is_completed
                    status
                }
            }`,
            variables() {
                return {
                    id: this.id,
                }
            },
            result(data) {
                this.loading = false;
                this.clinic = data.data.clinicCenter
                this.selectePreselectedData();
                
            },
        },
    },
    methods:{
        ...mapMutations(['storePurchase']),

        selectService(service){
            this.purchase.service = service;
            this.purchase.address = service.addresses[0];
            this.calcPrice()
        },

        selectAddress(selectedAddress){
            this.purchase.address = selectedAddress;
        },

        calcPrice(){
            if(this.purchase.service ){
                this.purchase.price = this.purchase.service.price;
            }
        },
        
        selectePreselectedData(){
            if( this.clinic.services.length == 1){
                this.selectService(this.clinic.services[0]);
            }
            
            if( this.$route.query.service && this.clinic.services.length >1){

                this.clinic.services.forEach( (service) => {
                    if( service.service.slug == this.$route.query.service ){
                        this.selectService(service);
                        this.showOnlySelectedService = true
                    }
                })
            }
            if (this.purchase.service.addresses && this.purchase.service.addresses.length>0){
                this.selectAddress(this.purchase.service.addresses[0])
            }
        },

        confirmPurchase(){
            if( !this.purchasing ){
                
                this.purchaseFieldsError = false;

                if( !this.purchase.service.id || !this.clinic.id  ){
                    this.purchaseFieldsError = true;
                    return false;
                }

                this.purchasing = true;
                
                if(!this.isAuthenticated){
                    this.$bvModal.show('modal-login')
                    this.purchasing = false;
                    return false;
                }

                this.purchase.clinic_id = this.clinic.id;
                this.storePurchase(this.purchase);
                this.$router.push('/service-checkout');
            }
        },
        closeLoginModal(){
            this.$bvModal.hide('modal-login')
            
        },        
    }
}
</script>

<style scoped>
.box_profile {
    background-color: #fff;
    text-align: center;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    border: 1px solid #e1e8ed;
    margin-bottom: 35px;
    overflow: hidden;
}

.box_profile figure {
    margin: -1px -26px 0px -26px;
    -webkit-border-radius: 5px 5px 0 0;
    -moz-border-radius: 5px 5px 0 0;
    -ms-border-radius: 5px 5px 0 0;
    border-radius: 5px 5px 0 0;
    overflow: hidden;
}

.box_profile_image{
    width:100%;
}
.box_profile_info{
    width: 100%;
    padding: 0 8px 0px 8px;
}

.box_profile .rating {
    margin-bottom: 20px;
    display: inline-block;
}

.box_profile small {
    text-transform: uppercase;
    color: #999;
    font-weight: 600;
}

.box_profile h1 {
    font-size: 21px;
    font-size: 1.3125rem;
}

.box_profile p {
    color: #999;
}

.box_profile ul.statistic {
    padding-bottom: 5px;
}

.box_profile ul.statistic li {
    display: inline-block;
    background-color: #74d1c6;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    border-radius: 3px;
    line-height: normal;
    color: #fff;
    padding: 3px 10px;
    font-weight: 600;
    font-size: 12px;
    font-size: 0.75rem;
    min-width: 95px;
}

.box_profile ul.contacts {
    text-align: center;
    
    border-top: 1px solid #ededed;
    border-bottom: 1px solid #ededed;
    padding: 12px;
    margin: 10px -25px 10px -25px;
}


.box_profile ul.contacts li {
    margin-bottom: 15px;
}

.box_profile ul.contacts li h6 {
    font-size: 14px;
    font-size: 0.875rem;
    margin-bottom: 3px;
}

.box_profile ul.contacts li:last-child {
    margin-bottom: 0;
}

.nav-tabs .nav-link{
    cursor: pointer;
}

.tabs_styled_2 .nav-tabs .nav-item.show .nav-link,
.tabs_styled_2 .nav-tabs .nav-link.active {
    color: #333333;
    background-color: #fff;
    border-color: #e1e8ed;
    border-bottom: 1px solid transparent;
    border-top: 2px solid #12bcec;
}

@media (max-width: 767px) {

    /* .tabs_styled_2 .nav-tabs .nav-item.show .nav-link,
    .tabs_styled_2 .nav-tabs .nav-link.active {
        border: 1px solid transparent;
    } */
}

.tabs_styled_2 .nav-tabs .nav-link:focus,
.tabs_styled_2 .nav-tabs .nav-link.active:hover {
    border-color: #e1e8ed;
    border-bottom: 1px solid transparent;
    border-top: 2px solid #12bcec;
}

@media (max-width: 767px) {

    /* .tabs_styled_2 .nav-tabs .nav-link:focus,
    .tabs_styled_2 .nav-tabs .nav-link.active:hover {
        
        border: 1px solid transparent;
    } */
}

.tabs_styled_2 .nav-tabs .nav-link:hover {
    border-color: transparent;
}

@media (max-width: 767px) {
    /* .tabs_styled_2 .nav-item {
        
        display: block;
        width: 100%;
        margin-bottom: 5px;
        border: 1px solid #e1e8ed;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        -ms-border-radius: 5px;
        border-radius: 5px;
    } */
}

.tabs_styled_2 .nav-tabs .nav-link {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    font-size: 16px;
    font-size: 1rem;
    padding: 0.75rem 1.5rem;
    margin-right: 5px;
}

@media (max-width: 767px) {
    .tabs_styled_2 .nav-tabs .nav-link {
        /* For less than 767px */
        margin-right: 0;
        padding: 0.5rem;
    }
}

.tabs_styled_2 .nav-tabs {
    border-bottom: 1px solid #e1e8ed;
}

.tabs_styled_2 .tab-pane {
    background-color: #fff;
    padding: 30px 30px 20px 30px;
    border: 1px solid #e1e8ed;
    border-top: none;
}

.tabs_styled_2 .tab-pane hr {
    margin: 30px -30px 30px -30px;
    border-color: #ededed;
}


.main_title_3 {
  background-color: #12bcec;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  border-radius: 5px;
  text-align: center;
  padding: 10px;
  position: relative;
  margin-bottom: 10px;
}
@media (max-width: 991px) {
  .main_title_3 {
    /* For less than 991px */
    margin-bottom: 30px;
  }
}
.main_title_3 h3 {
  font-size: 16px;
  font-size: 1rem;
  text-transform: uppercase;
  margin: 5px 0 0 0;
  position: relative;
  color: #fff;
}
.main_title_3 h3 strong {
  background-color: #106d88;
  color: #fff;
  text-align: center;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  border-radius: 50%;
  line-height: 24px;
  display: inline-block;
  width: 24px;
  height: 24px;
  font-size: 14px;
  font-size: 0.875rem;
  margin-right: 10px;
  position: relative;
  top: -2px;
}
.main_title_3 h3:before, .main_title_3 h3:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 54px;
  bottom: -42px;
  display: block;
  z-index: 9;
}
@media (max-width: 991px) {
  .main_title_3 h3:before, .main_title_3 h3:after {
    /* For less than 991px */
    display: none;
  }
}
.main_title_3 h3:before {
  left: 25%;
  /* background: url(../img/arrow_left.png) no-repeat 0 0; */
}
.main_title_3 h3:after {
  right: 25%;
  /* background: url(../img/arrow_right.png) no-repeat 0 0; */
}

.custom-control{
    
    border-bottom: 1px solid #ccc;
}
.custom-control-label{
    user-select: none;
    width: 100%;
    display: block;
    cursor: pointer;
    padding: 8px;
}
.custom-control-label:before, .custom-control-label:after{
    margin: 4px;
}
.custom-control-label strong{
    float:right;
}


@media (min-width:576px) and (max-width: 991px) {
    .box_profile{
        padding:8px;
    }
    .box_profile_info{
        text-align:left;
    }

    .box_profile_image{
        width:150px;
        float: left;
    }
    .box_profile_info{
        width: calc(100% - 150px);
        float: left;
    }

    .box_profile ul.contacts{
        border:none;
        padding: 8px 0px;
        margin: 0px;
        text-align: left !important;
    }

}
@media (max-width: 991px) {
    
    .box_profile figure {
        /* For less than 991px */
        width: 100px;
        height: 100px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -ms-border-radius: 50%;
        border-radius: 50%;
        margin: 12px auto;
    }
}

.donator-badge{
    width: 100%;
    padding: 8px;
    background-color: #87cbc9;
    border-radius: 4px;
}
.donator-badge .stamp-content{
    display: flex;   
    align-items: center;
    justify-content: center; 
    color: #fff;
}

.donator-badge .stamp-content .donator-stamp{
    background-color: #fff;
    padding: 2px;
    border-radius: 50%;
    border: 2px solid #fff;
    flex-grow: 0;
    flex-shrink: 0;
}
/*
.donator-badge .stamp-content p{
    padding: 0px;
    margin: 0px;
    text-align: left;
    padding: 0px 0px 0px 8px;
    color: #fff;
    font-size: 13px;
    line-height: 14px;
}
.donator-badge .active-coupon{
    text-align: center;
    color: #fff;
    padding: 10px 0px 4px 0px;
    border-top: solid 1px #9ad6d4;
    margin-top: 12px;
}
.donator-badge .active-coupon .coupon{
 font-size: 20px;
 font-weight: 600;
} */


.services-table tr{
    border-bottom: solid 1px #f3f3f3;
}
.services-table tr td:first-child{
    padding-left: 18px;
}


.clinic-image{
    max-width:180px;
}

</style>
